<template>
    <div class="container my-5">
            <kurama-loader
            v-if="loader.load"
            :msj="loader.msg"
        />
        <div class="d-flex flex-wrap justify-content-center">
            <div v-for="(permiso, x) in Permisos" :key="x">
                <router-link :to="{ name: permiso.clave}" custom v-slot="{ navigate, href, route   }">
                <!--<a :href="href" @click="navigate" >-->
                    <!-- {{permiso}} -->
                     <!-- {{permiso.clave}}  -->
                     <!-- v-if="permiso.clave!='000009' && permiso.clave!='000008'"  -->
                    <div class="card-menu" @click="recargarPage(route)" style="cursor:pointer"> 
                        <div class="container-card">
                            <div class="d-flex justify-content-center">                                
                                <img style="width: 90px;" :src="require(`@/assets/img/iconSubsistemas/${permiso.clave}.svg`)" 
                                :alt="permiso.descripcionFuncion">
                            </div>
                            <div class="title-proyecto">
                                <p class="title" style="color:#A84875">{{permiso.descripcionFuncion}}</p>
                                <!-- <p class="title">{{permiso.descripcionFuncion}} - {{permiso.clave}}</p> -->
                            </div>
                        </div>                         
                    </div>
                    <!-- {{permiso.clave}}       -->
                <!--</a>-->
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import mapHelper from '@/store/modules/common/map-helper';
import GenericMixin from '@/mixins/GenericMixin';

export default{
    data(){
        return {
            loader:{
                load: false,
                msg:''
            }
        }
    },
    mixins: [GenericMixin],
    name: 'inical',
    computed:{
        Permisos(){ return this.$store.getters[mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.getPermisosPrincipal]; }
    },
    methods:{
        async recargarPage(route){
            this.$router.push({ name: route.name });
            //this.$forceUpdate();
            location.reload();  
        },
        /** funcion de prueba de carga de perfiles **/
        async cargarPerfilUser(idsubsistema){
            try{
                this.loader = {load: true,  msg: 'Cargando información. Por favor, espere...'}
                let response = await this.$store.dispatch(mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.buscarUsuario,idsubsistema);
                //console.log(response);
            }catch(error)
            { 
                console.log(error); 
            }
            finally{
                this.loader = {load: false, msg:''}
            }
        },
    }
}
</script>
<style scoped>
a { color: black; text-decoration: none; }
</style>